(function () {
  const featPhoto = document.querySelector(".product__page .product__photo:first-child");
  if (!featPhoto) {
    return; // if no product photo (not a product page), then don't run this script
  }

  const productsJson = JSON.parse(document.querySelector("[data-product-json]").innerHTML);

  const variantEl = document.querySelector("[name=id]");
  const prodImages = document.querySelector(".product__images");
  const imgWrapper = featPhoto.querySelector(".image-wrapper");
  const imgEl = imgWrapper.querySelector("img");
  const framePlaceholder = featPhoto.querySelector(".frame-placeholder");
  const mattePlaceholder = featPhoto.querySelector(".matte-placeholder");

  // checks variant for what is selected then render isomorphic 3d view of image
  function checkImageClass(variantId) {
    if (productsJson.type !== "Prints") {
      return;
    }
    featPhoto.parentElement.classList.remove("bg-padded-cream");
    framePlaceholder.classList.remove("mod--frame", "frame--wood", "frame--silver", "frame--gold");
    mattePlaceholder.classList.remove("mod--3d");
    imgEl.classList.remove("float-frame-inset");
    imgWrapper.classList.remove(
      "mod--acrylic",
      "shadow-md",
      "inch-border",
      "rotate35",
      "-rotate35",
    );
    imgWrapper.querySelectorAll(".rect").forEach((el) => el.classList.add("hidden"));
    const textEl = document.querySelector(".rotate-text-help");
    if (textEl) {
      textEl.classList.add("hidden");
    }

    const variant = productsJson.variants.find((v) => v.id == variantId);
    let match = false;
    imgEl.src = productsJson.featured_image;
    const option1 = variant ? variant.option1.toLowerCase() : "";
    if (option1.includes("frame")) {
      framePlaceholder.classList.add("mod--frame");
      if (option1.includes("wood") || option1.includes("natural")) {
        framePlaceholder.classList.add("frame--wood");
      } else if (option1.includes("gold")) {
        framePlaceholder.classList.add("frame--gold");
      } else if (option1.includes("silver")) {
        framePlaceholder.classList.add("frame--silver");
      }
      if (option1.includes("float frame")) {
        imgEl.classList.add("float-frame-inset");
      }
      if (productsJson.tags.includes("frame--matte")) {
        mattePlaceholder.classList.add("frame--matte");
      }
      match = true;
    } else if (option1.includes("acrylic")) {
      mattePlaceholder.classList.add("mod--3d");
      textEl.classList.remove("hidden");
      imgWrapper.classList.add("mod--acrylic", "rotate35");
      imgWrapper.querySelectorAll(".rect").forEach((el) => el.classList.remove("hidden"));
      if (variant.featured_image) {
        imgEl.src = variant.featured_image.src;
      }
      match = true;
    } else if (option1.includes("print only")) {
      imgWrapper.classList.add("shadow-md");
      if (
        !productsJson.tags.includes("remove-1inch-border") &&
        productsJson.tags.includes("frame--matte")
      ) {
        imgWrapper.classList.add("inch-border");
      }
      match = true;
    }
    if (match) {
      featPhoto.parentElement.classList.add("bg-padded-cream");
    }
  }

  function imageRenderer() {
    try {
      if (productsJson.type !== "Prints") {
        return;
      }

      imgEl.removeAttribute("srcset"); // this is needed to let our src switch to acrylic work
      // add acrylic elements to be rendered
      if (imgWrapper && !imgWrapper.querySelector(".sintra")) {
        const sintraDiv = document.createElement("div");
        sintraDiv.classList.add("rect", "sintra");
        sintraDiv.innerHTML =
          '<div class="plane back"></div><div class="plane right"></div><div class="plane left"></div><div class="plane top"></div><div class="plane bot"></div>';
        const acrylicDiv = document.createElement("div");
        acrylicDiv.classList.add("rect", "acrylic");
        acrylicDiv.innerHTML =
          '<div class="plane right"></div><div class="plane left"></div><div class="plane top"></div><div class="plane bot"></div>';
        imgWrapper.prepend(sintraDiv);
        imgWrapper.append(acrylicDiv);
        const textSpan = document.createElement("span");
        textSpan.classList.add("rotate-text-help");
        textSpan.innerText = "click on image to rotate";
        prodImages.append(textSpan);
      }
      // add matte container
      imgWrapper.addEventListener("click", () => {
        const variant = productsJson.variants.find((v) => v.id == variantEl.value);
        if (variant && variant.option1.includes("Acrylic")) {
          imgWrapper.classList.toggle("rotate35");
          imgWrapper.classList.toggle("-rotate35");
        }
      });
      checkImageClass(variantEl.value);
    } catch (e) {
      console.warn("failed to update image rendering", e.message);
    }
  }

  function hideUnavailableVariants(variantId, currentTarget) {
    const variant = productsJson.variants.find((v) => v.id == variantId);
    // if selected variant is not available, then select first available variant
    if (!variant) {
      const availableVariant = productsJson.variants.find(
        (v) => v[currentTarget.dataset.index] === currentTarget.value,
      );
      if (availableVariant) {
        const opt2El = document.querySelector(
          `[data-value="${availableVariant.option2.replace(/"/g, '\\"')}"]`,
        );
        if (opt2El) {
          opt2El.click();
        }
        // select first available variant on UI for options display to switch
      }
    }
  }

  function runSizingLogicForWallPreview(curVariant) {
    // get bounding box size of current wall image
    const wallImg = document.querySelector(".wall-images .selected");
    if (!wallImg) {
      return;
    }
    const { width: containerWidth, height: containerHeight } = wallImg.getBoundingClientRect();
    const imgWidth = Number(wallImg.dataset.imageWidth);
    const imgHeight = Number(wallImg.dataset.imageHeight);
    const density = Number(wallImg.dataset.density);

    const sizeIndex = productsJson.options.findIndex((o) => o.toLowerCase() === "size");
    const size = curVariant[`option${sizeIndex + 1}`].toLowerCase();
    const regex = /([0-9.]+)\W*x\s*([0-9.]+)/g;
    let printWidth = 0;
    let _printHeight = 0;
    // loop through all matches and use the last match for print width and height
    for (const match of size.matchAll(regex)) {
      printWidth = match[1];
      _printHeight = match[2];
    }
    const frameWidthPx = printWidth * density;
    // const frameHeightPx = _printHeight * density;

    // now scale everything down to the container size bounding box
    const scaleFactor = Math.min(containerWidth / imgWidth, containerHeight / imgHeight);
    const frameImgWidth = frameWidthPx * scaleFactor;
    // const frameImgHeight = frameHeightPx * scaleFactor;

    // now we can set the frame image width and height
    const frameEl = document.querySelector(".wall-preview-container .frame-image");
    frameEl.style.left = `${wallImg.dataset.leftOffset}%`;
    frameEl.style.top = `${wallImg.dataset.topOffset}%`;
    frameEl.style.width = `${wallImg.dataset.boxWidth - wallImg.dataset.leftOffset}%`;
    frameEl.style.height = `${wallImg.dataset.boxHeight - wallImg.dataset.topOffset}%`;
    frameEl.style.display = "flex";
    const frameImgEl = frameEl.querySelector(".product__slide");
    frameImgEl.style.width = `${frameImgWidth}px`;
    // frameImgEl.style.height = `${frameImgHeight}px`;

    const frameImg = document.querySelector(".frame-image .frame-placeholder");
    const mattePH = document.querySelector(".frame-image .matte-placeholder");
    const imgWrap = document.querySelector(".frame-image .image-wrapper");
    frameImg.classList.remove("mod--frame", "frame--wood", "frame--gold", "frame--silver");
    mattePH.classList.remove("frame--matte", "mod--3d");
    imgWrap.classList.remove("mod--acrylic", "inch-border");
    imgWrap.querySelectorAll(".rect").forEach((el) => el.classList.add("hidden"));

    const option1 = curVariant.option1.toLowerCase();
    if (option1.includes("frame")) {
      frameImg.classList.add("mod--frame");
      if (option1.includes("wood") || option1.includes("natural")) {
        frameImg.classList.add("frame--wood");
      } else if (option1.includes("gold")) {
        frameImg.classList.add("frame--gold");
      } else if (option1.includes("silver")) {
        frameImg.classList.add("frame--silver");
      }
      if (productsJson.tags.includes("frame--matte")) {
        mattePH.classList.add("frame--matte");
      }
    } else if (option1.includes("acrylic")) {
      // Maybe do this later?
      // mattePH.classList.add("mod--3d");
      // imgWrap.classList.add("mod--acrylic", "rotate35");
      // imgWrap
      //   .querySelectorAll(".rect")
      //   .forEach((el) => el.classList.remove("hidden"));
      // imgWrap.querySelector('img').src = curVariant.featured_image.src;
    } else if (option1.includes("print only")) {
      if (
        !productsJson.tags.includes("remove-1inch-border") &&
        productsJson.tags.includes("frame--matte")
      ) {
        imgWrap.classList.add("inch-border");
      }
    }
  }

  function initWallPreview(curVariant) {
    // size the frame image
    runSizingLogicForWallPreview(curVariant);

    const thumbnails = document.querySelector(".wall-thumbnails");
    if (!thumbnails) {
      return; // Do nothing, there's no thumbnail to process
    }
    thumbnails.querySelectorAll(".product__photo").forEach((photoEl) => {
      photoEl.addEventListener("click", () => {
        const currentWallSelection = document.querySelector(".wall-images .selected");
        const mainWallImg = document.querySelector(
          `.wall-images [data-index="${photoEl.dataset.index}"]`,
        );
        const curThumbnail = document.querySelector(".wall-thumbnails .selected");
        if (mainWallImg) {
          const variant = productsJson.variants.find((v) => v.id == variantEl.value);
          if (curThumbnail) {
            curThumbnail.classList.remove("selected");
          }
          if (currentWallSelection) {
            currentWallSelection.classList.remove("selected");
          }
          mainWallImg.classList.add("selected");
          photoEl.classList.add("selected");
          runSizingLogicForWallPreview(variant);
        }
      });
    });
  }

  function updateSelectedImage(variantId) {
    const variant = productsJson.variants.find((v) => v.id == variantId);
    const currentActive = document.querySelector("[data-active-image]");
    if (currentActive && variant) {
      currentActive.setAttribute(
        "data-active-image",
        `${productsJson.options[0].toLowerCase()}: ${variant.options[0].toLowerCase()}`,
      );
    }
  }

  window.addEventListener("load", () => {
    const selectorsEl = document.querySelector(".product__selectors");
    if (selectorsEl) {
      selectorsEl.addEventListener("change", function ({ target }) {
        hideUnavailableVariants(variantEl.value, target);
      });
    }
    variantEl.addEventListener("change", function ({ currentTarget }) {
      if (currentTarget.value) {
        checkImageClass(currentTarget.value);

        const variant = productsJson.variants.find((v) => v.id == currentTarget.value);
        runSizingLogicForWallPreview(variant);

        updateSelectedImage(currentTarget.value);
      }
    });
    imageRenderer();
    const variant = productsJson.variants.find((v) => v.id == variantEl.value);
    initWallPreview(variant);
  });
})();
